import { enumify } from '../lib/typeInference.js';

export const CheckinTypeValues = ['AUTO', 'MANUAL', 'CFD', 'OFFLINE', 'UNKNOWN'] as const;
export type CheckinType = (typeof CheckinTypeValues)[number];
export const CheckinTypeEnum = enumify(CheckinTypeValues);

export const CheckinTriggerValues = ['GEO', 'BEACON', 'CODE', 'POS', 'UNKNOWN'] as const;
export type CheckinTrigger = (typeof CheckinTriggerValues)[number];
export const CheckinTriggerEnum = enumify(CheckinTriggerValues);

export const CheckinStateValues = ['CHECKEDIN'] as const;
export type CheckinState = (typeof CheckinStateValues)[number];
export const CheckinStateEnum = enumify(CheckinStateValues);

export interface ICheckin<IDTYPE> {
    _id: IDTYPE;
    userId: IDTYPE;
    tenantId: IDTYPE;
    locationId: IDTYPE;
    locationTitle: string;
    created: Date;
    updated: Date;
    expiresAt?: Date;
    userFullName?: string;
    userDefaultTip?: string;
    state: CheckinState;
    type: CheckinType;
    trigger: CheckinTrigger;
}
